import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { reportTrialSignupConversion } from './googleAdsConfig';

export { initGoogleAds, reportTrialSignupConversion } from './googleAdsConfig';

/**
 * Fires the trial-signup conversion when the customer first reaches the setup
 * wizard.
 *
 * /setup is the right moment: it is reached exactly once per new account, right
 * after registration succeeds, whereas /register is also hit by visitors who
 * never complete signup. Mount once inside the Router.
 */
export function GoogleAdsConversionTracker() {
  const location = useLocation();
  // Guards against double-reporting within a single mount (StrictMode runs
  // effects twice in development).
  const firedRef = useRef(false);

  useEffect(() => {
    if (firedRef.current) return;
    if (!location.pathname.startsWith('/setup')) return;
    firedRef.current = true;
    reportTrialSignupConversion();
  }, [location.pathname]);

  return null;
}
